import "./RyanLoader.scss";

export const RyanLoader = () => {
  return (
    <div className="RyanLoader">
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="PingMapWorkspaceRyanLoader__SVGSpin"
      >
        <rect
          x="9.12891"
          y="2.60938"
          width="21.7391"
          height="34.7826"
          rx="10.8696"
          stroke="#C94DFF"
        />
        <rect
          x="15.3887"
          y="39.9844"
          width="21.7391"
          height="34.7826"
          rx="10.8696"
          transform="rotate(-135 15.3887 39.9844)"
          stroke="#3895FF"
        />
        <rect
          x="2.60742"
          y="30.8691"
          width="21.7391"
          height="34.7826"
          rx="10.8696"
          transform="rotate(-90 2.60742 30.8691)"
          stroke="#FFAC4D"
        />
        <rect
          x="0.015625"
          y="15.3887"
          width="21.7391"
          height="34.7826"
          rx="10.8696"
          transform="rotate(-45 0.015625 15.3887)"
          stroke="#F32C01"
        />
      </svg>
      <div className="PingMapWorkspaceRyanLoader__Text">
        Waiting on Ryan Location Services
      </div>
    </div>
  );
};
